import {connect} from 'react-redux';
import {Timer as Component} from './Timer';
import {
  createTimer,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("timers") &&
     state.notebook.protocolSection.scene.apparatus.timers.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].type,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createTimer: (data)=>{
      dispatch(createTimer(data))
    },
  };
}

export const Timer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
